import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService, MetricsService, TRACKABLE_EVENTS } from '@fb-tool-front/core/services';
import { ErrorPageMessage } from '@fb-tool-front/shared/interfaces/shared.type';
import { Observable } from 'rxjs';
import { LOCATION } from '@ng-web-apis/common';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit, OnDestroy {
  errorPageMessage$: Observable<ErrorPageMessage>;

  constructor(
    private metricsService: MetricsService,
    private appStateService: AppStateService,
    private router: Router,
    @Inject(LOCATION) readonly location: Location
  ) {}

  ngOnInit() {
    if (!this.appStateService.errorPageMessage$$.value) {
      this.router.navigate([''], { replaceUrl: true });
    }

    this.errorPageMessage$ = this.appStateService.errorPageMessage$;
  }

  ngOnDestroy() {
    this.appStateService.errorPageMessage$$.next(null);
  }

  loginWithFacebook(authorizationUrl: string) {
    this.metricsService.trackEvent(TRACKABLE_EVENTS.loginWithFacebook());
    this.location.href = `${authorizationUrl}&success_url=${this.location.origin}&failure_url=${this.location.origin}`;
  }
}
